import { useMemo } from 'react';

import { PlusOutlined, SyncOutlined } from '@ant-design/icons';
import { Flex } from '@revenuemarket/cds';
import { overlays } from '@revenuemarket/overlays';
import { Button, Divider, Select } from 'antd';

import CustomLabelSettingModal from '~components/CashFlow/CustomLabelSettingModal';
import { useGroupLabels } from '~hooks/queries/custom-labels/query';
import { useDemoAwareCompanyId } from '~hooks/useDemoAwareCompanyId';
import { MIXPANEL_EVENT } from '~libs/mixpanel/event';
import { mixpanel } from '~pages/_app';

interface Props {
  value: number | null;
  onChange: (value: number | null) => void;
  style?: React.CSSProperties;
}

const GroupLabelSelect: React.FC<Props> = ({ value, onChange, style }) => {
  const { companyId } = useDemoAwareCompanyId();
  const { data: groupLabelData } = useGroupLabels({ companyId });
  const groupLabelOptions =
    useMemo(
      () =>
        groupLabelData?.Data?.data?.map((customLabel) => ({
          label: customLabel.name,
          value: customLabel.id,
        })),
      [groupLabelData],
    ) || [];

  return (
    <Select
      style={{ ...style }}
      value={value}
      options={groupLabelOptions}
      showSearch
      filterOption={(input, option) => {
        return (option?.label ?? '')?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
      placeholder="그룹 분류 선택"
      onChange={(value) => {
        onChange(value);
      }}
      dropdownRender={(menu) => {
        return (
          <Flex direction="column">
            {menu}
            <Divider
              style={{
                margin: '8px 0px',
              }}
            />
            <Flex align="center">
              <Button
                icon={<PlusOutlined />}
                onClick={() => {
                  mixpanel.track(MIXPANEL_EVENT.LABEL.CLICK_ADD_GROUP_LABEL, {
                    page: location.pathname,
                  });
                  overlays.open(({ isOpen, onClose }) => (
                    <CustomLabelSettingModal open={isOpen} onCancel={onClose} />
                  ));
                }}
              >
                그룹분류 추가
              </Button>
              <Button
                type="link"
                icon={<SyncOutlined />}
                onClick={() => {
                  onChange(null);
                }}
              >
                그룹분류 초기화
              </Button>
            </Flex>
          </Flex>
        );
      }}
    />
  );
};

export default GroupLabelSelect;
